import { create } from 'zustand';

interface AuthState {
  token: string | null;
  subscription: string | null;
  user: string | null;
  api: string | null;
  isAuthenticated: boolean;
  setAuth: (token: string, subscription: string, user: string, api: string) => void;
  clearAuth: () => void;
  loadFromSession: () => void;
}

export const useAuthStore = create<AuthState>((set) => ({
  token: null,
  subscription: null,
  user: null,
  api: null,
  isAuthenticated: false,
  
  setAuth: (token: string, subscription: string, user: string, api: string) => {
    // Guardar en sessionStorage
    sessionStorage.setItem('whin_token', token);
    sessionStorage.setItem('whin_subscription', subscription);
    sessionStorage.setItem('whin_user', user);
    sessionStorage.setItem('whin_api', api);
    
    set({
      token,
      subscription,
      user,
      api,
      isAuthenticated: true
    });
  },
  
  clearAuth: () => {
    // Limpiar sessionStorage
    sessionStorage.removeItem('whin_token');
    sessionStorage.removeItem('whin_subscription');
    sessionStorage.removeItem('whin_user');
    sessionStorage.removeItem('whin_api');
    
    set({
      token: null,
      subscription: null,
      user: null,
      api: null,
      isAuthenticated: false
    });
  },
  
  loadFromSession: () => {
    const token = sessionStorage.getItem('whin_token');
    const subscription = sessionStorage.getItem('whin_subscription');
    const user = sessionStorage.getItem('whin_user');
    const api = sessionStorage.getItem('whin_api');
    
    if (token && subscription && user && api) {
      set({
        token,
        subscription,
        user,
        api,
        isAuthenticated: true
      });
    }
  }
}));
